import type { BillingInfoFormData, BillingInfoFormValues } from '@ctct/application-layer';
import { FormFieldNonFekit, FormFieldCheckboxNonFekit, FormFieldSelectNonFekit } from '@ctct/presentation-layer';

import type { BillingInfoFormCopy } from './types';

interface Props {
  countries?: ReturnType<BillingInfoFormData['getCountries']>;
  isShowingStates?: boolean;
  statePlaceholder?: string;
  states?: ReturnType<BillingInfoFormData['getStates']>;
  emailList?: ReturnType<BillingInfoFormData['getEmailList']>;
  copy: BillingInfoFormCopy;
  // vat
  showTaxAgreement: boolean;
  showTaxNumber: boolean;
  taxDisclaimer: string;
  taxLabel: string;
}

export const BillingInfoForm = ({
  countries = [],
  isShowingStates = false,
  statePlaceholder,
  states = [],
  emailList = [],
  showTaxAgreement,
  showTaxNumber,
  taxDisclaimer,
  taxLabel,
  copy,
}: Props) => {
  return (
    <div className="grid-form-container billing-info-form-container">
      <FormFieldNonFekit<BillingInfoFormValues> name="firstname" qeId="field-fname" placeholder={copy.firstName} />

      <FormFieldNonFekit<BillingInfoFormValues> name="lastname" qeId="field-lname" placeholder={copy.lastName} />

      <FormFieldNonFekit<BillingInfoFormValues> name="phone" qeId="field-phone" placeholder={copy.phone} type="tel" />

      <FormFieldNonFekit<BillingInfoFormValues>
        name="companyname"
        qeId="field-companyname"
        placeholder={copy.companyOrOrganization}
      />

      <FormFieldSelectNonFekit<BillingInfoFormValues> name="country" qeId="field-countries" items={countries} />

      <FormFieldNonFekit<BillingInfoFormValues>
        name="address1"
        qeId="field-streetAddress1"
        placeholder={copy.addressLine1}
      />

      <FormFieldNonFekit<BillingInfoFormValues>
        name="address2"
        qeId="field-streetAddress2"
        placeholder={copy.addressLine2}
      />
      <div className="columns-container">
        <FormFieldNonFekit<BillingInfoFormValues> name="city" qeId="field-city" placeholder={copy.city} />

        {isShowingStates && (
          <FormFieldSelectNonFekit<BillingInfoFormValues>
            name="state"
            qeId="field-state"
            items={states}
            placeholder={statePlaceholder ?? copy.selectState}
            allowEmpty
          />
        )}

        <FormFieldNonFekit<BillingInfoFormValues> name="zipcode" qeId="field-zipcode" placeholder={copy.postalCode} />
      </div>

      {showTaxNumber && (
        <FormFieldNonFekit<BillingInfoFormValues>
          name="vatNumber"
          qeId="field-vat-number"
          placeholder={taxLabel.concat(` ${copy.optional}`)}
          disableMarginBottom={showTaxAgreement}
        />
      )}

      {showTaxAgreement && (
        <FormFieldCheckboxNonFekit<BillingInfoFormValues>
          name="currentTaxAgreement"
          qeId="field-tax-agreement"
          placeholder={taxDisclaimer}
        />
      )}

      {emailList.length > 1 ? (
        <FormFieldSelectNonFekit<BillingInfoFormValues>
          name="email"
          qeId="field-email"
          items={emailList}
          disableMarginBottom
        />
      ) : (
        <FormFieldNonFekit<BillingInfoFormValues>
          name="email"
          qeId="field-email"
          placeholder={copy.billingEmail}
          disableMarginBottom
          disabled={emailList.length === 1}
        />
      )}
    </div>
  );
};
